import { gc } from "./declarations";

/**
 * The echo channel routes
 */
export const channelRoutes = {
    currentUser: () => `App.Models.User.${gc.user.value?.id}`,
    ordersForUser: () => `orders.user.${gc.user.value?.id}`,
}